import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import AdSlot from '../components/AdSlot'
import EzoicAdBatch from '../components/EzoicAdBatch'
import SEO from '../components/SEO'
import { fetchNewsBySlug } from '../services/api'
import '../styles/NewsDetail.scss'
import '../styles/NewsItem.scss'

interface News {
  id: string
  title: string
  summary: string
  image_url: string
  source_url: string
  published_at: string
  slug: string
}

const NEWSDETAIL_PLACEMENT_IDS = [109, 110] as const

function formatDate(isoDate: string): string {
  const date = new Date(isoDate)
  return date.toLocaleDateString('pt-BR')
}

const NewsDetail: React.FC = () => {
  const { slug } = useParams<{ slug: string }>()
  const [news, setNews] = useState<News | null>(null)

  useEffect(() => {
    const loadNews = async () => {
      if (!slug) {
        console.error('No news slug provided.')
        return
      }

      try {
        const fetchedNews: News = await fetchNewsBySlug(slug)
        setNews(fetchedNews)
      } catch (error) {
        console.error('Erro ao carregar a notícia:', error)
      }
    }

    loadNews()
  }, [slug])

  if (!news) return <div>Carregando...</div>

  return (
    <>
      <SEO
        title={`${news.title} - Resumi Pra Ti`}
        description={news.summary}
        url={`https://resumiprati.com.br/news/${news.slug}`}
        image={news.image_url}
      />

      <div className="home">
        {/* Ezoic: uma chamada por página para todos os slots do detalhe */}
        <EzoicAdBatch placementIds={[...NEWSDETAIL_PLACEMENT_IDS]} />

        <div className="news-item news-detail">
          {news.image_url && (
            <img
              src={news.image_url}
              alt={news.title}
              className="news-item__image"
            />
          )}

          {/* Ezoic: slot após a imagem */}
          <div>
            <AdSlot placementId={109} />
          </div>

          <div className="news-item__content">
            <h2 className="news-item__title">{news.title}</h2>
            <p className="news-item__date">{formatDate(news.published_at)}</p>
            <p className="news-item__summary">{news.summary}</p>

            {/* Ezoic: slot após o resumo */}
            <div>
              <AdSlot placementId={110} />
            </div>

            <div className="news-item__actions">
              <a
                href={news.source_url}
                target="_blank"
                rel="noopener noreferrer"
                className="news-item__source"
                aria-label="Ver notícia original"
              >
                Fonte da notícia
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default NewsDetail
